export default {"src":"/_next/static/media/logo-header-branca-hor.bbd0cfc8.svg","height":247,"width":844,"blurWidth":0,"blurHeight":0};